import { useProgress } from "@react-three/drei"
export function Loader(props) {
    const {setLoadingProgress} = props
    const { progress} = useProgress();
    // const { active, progress, errors, item, loaded, total } = useProgress();
    return setLoadingProgress(progress)
    // return setLoadingProgress(loaded * 100)
}